export const AssessmentData = {
  assessments: [
    {
      id: "7449860d-458c-4fae-81bb-af673555f625",
      name: "Senior Software Developer - ClickPe",
      status: "ACTIVE",
      createdAt: "2024-10-14T07:10:18.654Z",
      updatedAt: "2024-10-14T07:23:37.728Z",
      assessmentLinkActiveDuration: {
        endTime: "2024-10-17T13:49",
        startTime: "2024-10-15T12:49",
      },
      type: "ONLINE_WRITTEN",
      jobRole: "Python Developer",
      yearsOfExperience: { max: 5, min: 3 },
      usercount: "2",
    },
    {
      id: "881718b2-f3c6-48c5-8a16-738fc7655518",
      name: "Decentro",
      status: "ACTIVE",
      createdAt: "2024-07-25T10:39:10.444Z",
      updatedAt: "2024-07-25T10:51:48.373Z",
      assessmentLinkActiveDuration: {
        endTime: "2024-07-25T17:15",
        startTime: "2024-07-25T16:15",
      },
      type: "ONLINE_WRITTEN",
      jobRole: "SDE - Python",
      yearsOfExperience: { max: 4, min: 2 },
      usercount: "1",
    },
    {
      id: "c25535e3-1afe-4f8b-bbb0-7dfb7a8e6c8e",
      name: "H1 - Software Engineer I",
      status: "ACTIVE",
      createdAt: "2024-07-23T15:27:05.422Z",
      updatedAt: "2024-07-24T12:23:51.846Z",
      assessmentLinkActiveDuration: {
        endTime: "2024-07-30T14:59",
        startTime: "2024-07-23T13:59",
      },
      type: "ONLINE_WRITTEN",
      jobRole: "Software Engineer I",
      yearsOfExperience: { max: 3, min: 1 },
      usercount: "3",
    },
    {
      id: "5a1bcdef-9d37-4210-8ebc-99a3cd890abc",
      name: "React Developer - ABC Tech",
      status: "ACTIVE",
      createdAt: "2024-09-05T09:15:32.123Z",
      updatedAt: "2024-09-06T10:23:11.567Z",
      assessmentLinkActiveDuration: {
        endTime: "2024-09-10T17:00",
        startTime: "2024-09-05T12:00",
      },
      type: "ONLINE_WRITTEN",
      jobRole: "React Developer",
      yearsOfExperience: { max: 4, min: 2 },
      usercount: "5",
    },
    {
      id: "e2b567ef-1f89-4c34-905d-41f1b7e5f3a4",
      name: "DevOps Engineer - CloudOps",
      status: "ACTIVE",
      createdAt: "2024-06-20T10:30:00.111Z",
      updatedAt: "2024-06-21T12:45:30.222Z",
      assessmentLinkActiveDuration: {
        endTime: "2024-06-28T15:00",
        startTime: "2024-06-20T10:00",
      },
      type: "ONLINE_WRITTEN",
      jobRole: "DevOps Engineer",
      yearsOfExperience: { max: 7, min: 4 },
      usercount: "12",
    },
    {
      id: "881718b2-f3c6-48c5-8a16-738fc765518",
      name: "Data Engineer - Fintech Inc",
      status: "PAUSED",
      createdAt: "2024-08-22T10:00:00.654Z",
      updatedAt: "2024-08-25T12:00:45.654Z",
      assessmentLinkActiveDuration: {
        endTime: "2024-08-30T18:00",
        startTime: "2024-08-22T10:00",
      },
      type: "ONLINE_WRITTEN",
      jobRole: "Data Engineer",
      yearsOfExperience: { max: 6, min: 3 },
      usercount: "10",
    },
    {
      id: "ba5f67e3-813a-49b7-bc1d-3e7d1a9e07a1",
      name: "Java Backend Engineer - XYZ Ltd",
      status: "PAUSED",
      createdAt: "2024-08-15T14:42:28.987Z",
      updatedAt: "2024-08-16T16:30:45.342Z",
      assessmentLinkActiveDuration: {
        endTime: "2024-08-22T18:30",
        startTime: "2024-08-15T14:00",
      },
      type: "ONLINE_WRITTEN",
      jobRole: "Java Backend Engineer",
      yearsOfExperience: { max: 6, min: 3 },
      usercount: "8",
    },
    {
      id: "b34567cd-8e9a-4d78-99a1-23c8d4b7f5e9",
      name: "Machine Learning Engineer - AI Labs",
      status: "PAUSED",
      createdAt: "2024-04-12T07:40:00.049Z",
      updatedAt: "2024-04-13T08:04:41.314Z",
      assessmentLinkActiveDuration: {
        endTime: "2024-04-20T13:30",
        startTime: "2024-04-12T11:00",
      },
      type: "ONLINE_WRITTEN",
      jobRole: "Machine Learning Engineer",
      yearsOfExperience: { max: 6, min: 3 },
      usercount: "6",
    },

    {
      id: "d3a6f72a-c4b9-4f78-8993-5a8c7823c013",
      name: "Data Scientist - Big Data Corp",
      status: "DRAFT",
      createdAt: "2024-07-10T11:22:45.654Z",
      updatedAt: "2024-07-11T13:10:59.876Z",
      assessmentLinkActiveDuration: null,
      type: "ONLINE_WRITTEN",
      jobRole: "Data Scientist",
      yearsOfExperience: { max: 5, min: 2 },
      usercount: "0",
    },
    {
      id: "fa56789a-45cd-4f8e-bc1d-6e23a45ds8e12",
      name: "Cyber Security Analyst - SafeNet",
      status: "DRAFT",
      createdAt: "2024-05-15T08:25:45.999Z",
      updatedAt: "2024-05-16T09:55:15.678Z",
      assessmentLinkActiveDuration: null,
      type: "ONLINE_WRITTEN",
      jobRole: "Cyber Security Analyst",
      yearsOfExperience: { max: 5, min: 2 },
      usercount: "0",
    },
    {
      id: "fa56789a-45cd-4f8e-bc1d-6e23a45d8e12",
      name: "Data Analyst - SafeNet",
      status: "DRAFT",
      createdAt: "2024-05-15T08:25:45.999Z",
      updatedAt: "2024-05-16T09:55:15.678Z",
      assessmentLinkActiveDuration: null,
      type: "ONLINE_WRITTEN",
      jobRole: "Data Analyst",
      yearsOfExperience: { max: 5, min: 2 },
      usercount: "10",
    },
    {
      id: "c25535e3-1afe-4f8b-bbb0-7dfsb7a8e6c8e",
      name: "H2 - Software Engineer I",
      status: "ACTIVE",
      createdAt: "2024-07-23T15:27:05.422Z",
      updatedAt: "2024-07-24T12:23:51.846Z",
      assessmentLinkActiveDuration: {
        endTime: "2024-07-30T14:59",
        startTime: "2024-07-23T13:59",
      },
      type: "ONLINE_WRITTEN",
      jobRole: "Software Engineer II",
      yearsOfExperience: { max: 3, min: 1 },
      usercount: "15",
    },
    {
      id: "881718b2-f3c6-48c5-8a16-738fc7s655518",
      name: "Decentro SDE",
      status: "ACTIVE",
      createdAt: "2024-07-25T10:39:10.444Z",
      updatedAt: "2024-07-25T10:51:48.373Z",
      assessmentLinkActiveDuration: {
        endTime: "2024-07-25T17:15",
        startTime: "2024-07-25T16:15",
      },
      type: "ONLINE_WRITTEN",
      jobRole: "SDE - JS",
      yearsOfExperience: { max: 4, min: 2 },
      usercount: "11",
    },
  ],
};
